import { TranslationsContext } from '@teliaee/telia-translate';
import { Card, CardContent, Heading, Separator, Tabs, TabsItem, THeadingLevel } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import OperatorGeneralInfo from './OperatorGeneralInfo';
import OperatorSelection from './OperatorSelection';
import CallsServiceGroup from './services/CallsServiceGroup';
import InternetServiceGroup from './services/InternetServiceGroup';

interface OperatorRoamingPricesProps {
  roamingStore?: RoamingStore;
  headingLevel?: THeadingLevel;
}

@observer
class OperatorRoamingPrices extends React.Component<OperatorRoamingPricesProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const { roamingStore, headingLevel = 2 } = this.props;
    const translate = this.context.translate;

    return (
      <>
        <Separator spacing="small" color="invisible" />
        <Heading level={headingLevel} className="h3" id="price-info">
          {translate('roaming.operator.heading')}
        </Heading>
        <Separator spacing="small" color="invisible" />
        <Card className="background-color: card--grey">
          <CardContent>
            {roamingStore.selectedCountry.isoCode !== 'RUS' && <OperatorSelection />}
            <Separator spacing="xsmall" color="invisible" />
            <Tabs aria-labelledby="price-info" border="top" defaultCurrentTab="calls-and-messages" headingLevel={(headingLevel + 1) as THeadingLevel}>
              <TabsItem id="calls-and-messages" label={translate('roaming.operator.calls-and-messages')}>
                <CallsServiceGroup />
              </TabsItem>
              <TabsItem id="internet" label={translate('roaming.operator.internet')}>
                <InternetServiceGroup />
              </TabsItem>
              {roamingStore.selectedCountry.isoCode !== 'RUS' && (
                <TabsItem id="operator" label={translate('roaming.operator.operator')}>
                  <OperatorGeneralInfo />
                </TabsItem>
              )}
            </Tabs>
          </CardContent>
        </Card>
      </>
    );
  }
}

export default inject('roamingStore')(OperatorRoamingPrices);
